module.exports = __webpack_public_path__ + "static/media/attribute_atk_up_aura.a2288b9c.png";